<template>
  <v-alert color="warning" rounded="0" outlined text class="mb-0">
    <span class="text-body-2 text--primary">
      Please complete your information in &nbsp;&nbsp;<a href="/my-account/profile" class="font-weight-semibold">Profile</a>
    </span>
  </v-alert>
</template>
<script>
export default {};
</script>

<style lang="sass" scoped>
</style>
